export const MODIFY_CONNECTED_DOMAINS = 'MODIFY_CONNECTED_DOMAINS';

export function modifyConnectedDomains(connectedDomains){
    return{
        type: MODIFY_CONNECTED_DOMAINS,
        mainState: {
            connectedDomains: connectedDomains
        }
    }
}